<template>
  <div class="page-content">
    <div class="page-title">Partaners</div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="Name">
        <el-input v-model="formInline.user" placeholder=""></el-input>
      </el-form-item>
      <el-form-item>
        <el-link type="primary">Search</el-link>
      </el-form-item>
    </el-form>
    <div class="list-view">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="item-header">
          <img :src="item.img" alt="" />
          <div class="header-info">
            <div class="info-title">{{ item.name }}</div>
            <div class="info-line">
              <span class="label">Term of Cooperation：</span
              ><span>{{ item.createTime }}</span>
            </div>
            <div class="info-line"></div>
          </div>
        </div>
        <div class="item-detail">
          <div class="detail-item">
            <div class="item-label">Brief Introduction：</div>
            <div class="item-text">
              {{ item.brief }}
            </div>
          </div>
          <div class="detail-item">
            <div class="item-label">Scope of Cooperation：</div>
            <div class="item-text">
              {{ item.donate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {
      formInline: {},
      list: [],
    };
  },
  created() {},
  mounted() {
    this.$get(this.$api + "/un/webpartnership/list", {}).then((res) => {
      this.list = res.rows;
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content {
    padding: 0 !important;
    ::v-deep .el-form {
      .el-form-item {
        width: 100% !important;
        input {
          width: 100%;
        }
      }
      .el-link--inner {
        width: 50vw;
        background-color: #00a0e1;
        padding: 2px 0 !important;
        color: #fff;
        border-radius: 30px !important;
        text-align: center;
        margin-left: 25vw !important;
      }
      .el-link.el-link--primary:hover::after {
        display: none !important;
      }
      &.el-form--inline .el-form-item__content {
        width: 80% !important;
      }
    }

    .list-view {
      .list-item {
        padding: 16px !important;
        .detail-item {
          margin-top: 0 !important;
        }
        .item-header {
          flex-wrap: wrap;
          img {
            width: 100%;
          }
          .info-title {
            font-size: 18px !important;
            line-height: 24px !important;
            margin-top: 20px !important;
          }
        }
      }
    }
  }
}
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  ::v-deep .el-form {
    padding-top: fh(40vh, pc);
    padding-bottom: fh(40vh, pc);
    .el-form-item {
      margin-right: fw(20vw, pc);
      .el-form-item__label {
        color: #2a2a2a;
        font-size: fh(18vh, pc);
      }
      .el-input__inner {
        width: fw(288vw, pc);
        border-radius: 50px;
      }
    }
  }

  .list-view {
    .list-item {
      padding: fh(40vh, pc) fw(40vw, pc);
      margin-bottom: fh(20vh, pc);
      background-color: #f7f7f7;
      border-radius: 8px;
      .item-header {
        width: 100%;
        display: flex;
        img {
          display: block;
          width: fw(240vw, pc);
        }
        .header-info {
          padding-left: fw(40vw, pc);
          display: flex;
          flex: 1;
          flex-direction: column;
          .info-title {
            font-size: fh(32vh, pc);
            color: #333333;
            line-height: fh(46vh, pc);
            font-weight: 600;
            margin-bottom: fh(20vh, pc);
          }
          .info-line {
            font-size: fh(18vh, pc);
            color: #333;
            line-height: fh(28vh, pc);
            .label {
              font-size: fh(24vh, pc);
              color: #999999;
              line-height: fh(34vh, pc);
              font-weight: 600;
            }
            &:nth-last-child(1) {
              margin-top: fh(38vh, pc);
            }
          }
        }
      }
      .item-detail {
        .detail-item {
          margin-top: fh(40vh, pc);
          .item-label {
            font-size: fh(24vh, pc);
            line-height: fh(30vh, pc);
            color: #999999;
            font-weight: bold;
          }
          .item-text {
            font-size: fh(18vh, pc);
            line-height: fh(28vh, pc);
            color: #333;
            margin-top: fh(20vh, pc);
          }
        }
      }
    }
  }
}
</style>
